import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getTitleGroups(data) {
    return request.get(`/${platform}/title_group`,data)
}

export function storeOrUpdateAtpFeed(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/title_group/${data.id}` : `/${platform}/title_group`;
    return request[method](url, data)
}

export function deleteTitleGroup(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/title_group/${ids}`)
}